import React from 'react';
import { addressFormatter } from '../Address';
import { has } from '../../../Services/helpers';
import { useCustomer } from '../../../Data/Customers';
import { useSession } from '../../Session';
import { NoValue } from '@/Components/Primitives';

const MAX_ADDRESS_SEGMENTS = 3;

const Subtitle = ({customer, customerId, className, fallback = null, address}) => {
    const shouldLoadCustomer = !!customerId && !customer;
    const {customer: loadedCustomer} = useCustomer(
        shouldLoadCustomer ? customerId : null,
        false,
        shouldLoadCustomer,
    );
    const {showRedesign} = useSession();

    return <span className={className ?? ''}>
        {getSubTitle(customer || loadedCustomer, fallback, showRedesign, address)}
    </span>
}

const getSubTitle = (customer, fallback, showRedesign, address) => {

    if (!customer) {
        return <NoValue />
    }

    const addressToUse = address ?? customer.address;
    const formattedAddress = addressFormatter(addressToUse, MAX_ADDRESS_SEGMENTS);

    if (showRedesign) {
        if (customer.type === 'Business' && has(customer.businessName)) {
            return customer.businessName;
        }

        if (has(customer.name)) {
            return customer.name;
        }

        if (has(formattedAddress)) {
            return formattedAddress;
        }
    }

    if (has(customer.name)) {
        return formattedAddress;
    }

    return fallback;
}

export default Subtitle;

export {
    getSubTitle,
}
